module.exports = __webpack_public_path__ + "static/angular-4d690a9164aeedd312d554eb9f048364.png";